import React from "react";
import { Badge, Col, Row, Stack } from "react-bootstrap";

// Icons
import * as AiIcons from "react-icons/ai";
import { FormatDateWTime } from "../../utils/FormatData";
import AdvanceTableWrapper from "../../components/AdvanceTableWrapper";
import BtnExportToExcell from "../../utils/BtnExportToExcell";
import AdvanceTable from "../../components/AdvanceTable";
import AdvanceTablePagination from "../../components/AdvanceTablePagination";
import AdvanceTableFooter from "../../components/AdvanceTableFooter";
import PropTypes from "prop-types";

const columns = [
  {
    accessor: "vc_message",
    Header: "Mensaje",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Row>
            <Col className="DateDetails">
              <b>{rowInfo.vc_message}</b>
            </Col>
          </Row>
        </>
      );
    },
  },
  {
    accessor: "tst_create",
    Header: "Recepcion",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Row>
            <Col className="DateDetails">
              {FormatDateWTime(rowInfo.tst_create)}
            </Col>
          </Row>
        </>
      );
    },
  },
  {
    accessor: "vc_carrier",
    Header: "Carrier",
  },
  {
    accessor: "vc_shortcode",
    Header: "ShortCode",
  },
  {
    accessor: "vc_keywords",
    Header: "Keyword",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <Row>
            <Col className="DateDetails">
              <b>{rowInfo.vc_keywords}</b>
            </Col>
          </Row>
        </>
      );
    },
  },
  {
    accessor: "b_read",
    Header: "Status",
    Cell: (rowData) => {
      let rowInfo = rowData.row.original;
      return (
        <>
          <div className="right">
            <Badge bg={rowInfo.b_read == "true" ? "success" : "danger"}>
              {rowInfo.b_read}
            </Badge>
          </div>
        </>
      );
    },
  },
];
const ReportMoSmsList = ({ listMessages, periodStr }) => {
  return (
    <>
      {listMessages && (
        <AdvanceTableWrapper
          columns={columns}
          data={listMessages}
          sortable
          pagination
          perPage={10}
        >
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="DbDetails2">
                <Stack direction="horizontal" gap={2}>
                  <AiIcons.AiOutlineCalendar />
                  <div className="ms-auto">
                    <p>{periodStr}</p>
                  </div>
                </Stack>
                <div className="details">Rango de fechas</div>
              </div>
            </Col>
          </Row>
          <div>
            <div style={{ textAlign: "left" }}>
              <h4>Lista de Mensajes</h4>
            </div>
            <div style={{ textAlign: "right" }}>
              <BtnExportToExcell
                dataReport={listMessages}
                fileName="SMS_Report"
              ></BtnExportToExcell>
            </div>
          </div>

          <AdvanceTable
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              size: "sm",
              striped: true,
              className: "fs--1 mb-0 overflow-hidden",
            }}
          />
          <AdvanceTablePagination table />
          <AdvanceTableFooter
            rowCount={listMessages.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
            pageSize={10}
          />
        </AdvanceTableWrapper>
      )}
    </>
  );
};
ReportMoSmsList.propTypes = {
  listMessages: PropTypes.array.isRequired,
  periodStr: PropTypes.string.isRequired,
};
export default ReportMoSmsList;
